import { IconProps } from "../../utils/global-types/global-types";

const TextFormattingIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M2.066 14.65v2.1h14.7v-2.1H2.066ZM6.791 10.24h5.25l.945 2.31h2.205L10.204 1H8.629L3.641 12.55h2.205l.945-2.31Zm2.625-7.161 1.964 5.271H7.453l1.963-5.271Z"
    />
  </svg>
);

export default TextFormattingIcon;
